import * as React from "react";
const SvgStar = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m12 3.44 2.781 5.636L21 9.979l-4.5 4.387 1.062 6.194L12 17.635 6.438 20.56 7.5 14.366 3 9.98l6.219-.903z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.69a.75.75 0 0 1 .673.418l2.606 5.282 5.829.847a.75.75 0 0 1 .415 1.28l-4.217 4.11.995 5.806a.75.75 0 0 1-1.088.79L12 18.484l-5.213 2.74a.75.75 0 0 1-1.088-.79l.995-5.805-4.217-4.111a.75.75 0 0 1 .415-1.28l5.829-.847 2.606-5.282A.75.75 0 0 1 12 2.69m0 2.445L9.892 9.408a.75.75 0 0 1-.565.41l-4.715.685 3.412 3.326a.75.75 0 0 1 .215.664l-.805 4.696 4.217-2.218a.75.75 0 0 1 .698 0l4.217 2.218-.805-4.696a.75.75 0 0 1 .216-.664l3.411-3.326-4.715-.685a.75.75 0 0 1-.565-.41z",
    clipRule: "evenodd"
  }
));
export default SvgStar;
